import { type FC } from 'react'

import { RoutesIcon } from '@dhl-ui/icons'
import { Chip, type ChipProps } from '@dhl-ui/components'

type Props = Pick<ChipProps, 'color' | 'size'> & {
  distance: number
}

export function renderDistance(distance: number): string {
  return `${Math.round(distance / 100) / 10}km`
}

export const ServicepointDistanceChip: FC<Props> = ({ color = 'default', distance, size }) => (
  <Chip isSquare color={color} label={renderDistance(distance)} startNode={<RoutesIcon />} size={size} />
)
